import _ from 'lodash';
import update from 'immutability-helper';

const initialState = {
  duplications: [],
  duplication: {},
};

const RECEIVE = 'duplication/RECEIVE';
const RESET = 'duplication/RESET';
const RECEIVE_ACTIVE_DUPLICATION_STATUS =
  'duplication/RECEIVE_ACTIVE_DUPLICATION_STATUS';
const RESET_ACTIVE_DUPLICATION_STATUS =
  'duplication/RESET_ACTIVE_DUPLICATION_STATUS';

export function receiveDuplicationStatus(payload) {
  return { type: RECEIVE, payload };
}

export function updateActiveDuplicationStatus(payload) {
  return { type: RECEIVE_ACTIVE_DUPLICATION_STATUS, payload };
}

export function resetActiveDuplicationStatus() {
  return { type: RESET_ACTIVE_DUPLICATION_STATUS, payload: {} };
}

export function resetDuplicationStatus() {
  return { type: RESET, payload: [] };
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case RECEIVE:
      return update(state, { duplications: { $set: payload } });

    case RECEIVE_ACTIVE_DUPLICATION_STATUS:
      return update(state, { duplication: { $set: payload } });

    case RESET:
      return update(state, { duplications: { $set: payload } });

    case RESET_ACTIVE_DUPLICATION_STATUS:
      return update(state, { duplication: { $set: payload } });

    default:
      return state;
  }
}
